import { Stack } from '../Stack';
import { styled } from '../styled';

export const ListStyled = styled(Stack)({
  margin: 0,
  paddingLeft: 16,
});
